import React from 'react';
import Chrome from '@uiw/react-color-chrome';
import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';
import { CloseButton } from '~/ui/buttons/CloseButton';

const Wrapper = styled.div`
  position: absolute;
  z-index: 1000;
  top: 100px;
  right: 15px;
`;

const Container = styled.div`
  position: relative;
  padding: 20px;

  background-color: #fff;

  gap: 0px;
  border-radius: 8px;

  box-shadow: rgba(0, 0, 0, 0.31) 3px 3px 5px;

  .topSection {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    margin-bottom: 10px;

    p {
      font-family: Raleway;
      font-size: 14px;
      font-weight: 700;
      line-height: 21px;
    }

    input {
      width: 115px;
      border: 1.08px solid #e0e0e0;
      padding: 5px;
      border-radius: 8px;
    }

    .closeBtn {
      position: relative;
      top: 0px;
      right: 0px;
      left: 5px;
    }
  }

  .colors {
    display: flex;
    gap: 10px;
  }
`;

const SelectColor = styled.div`
  background-color: ${props => props.color};

  width: 35.78px;
  height: 35.78px;
  gap: 0px;
  border-radius: 2.17px;
  border: 1.08px solid #e0e0e0;
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`;

const ColorPicker = ({
  hsva,
  setHsva,
  updateColor,
  onClose
}: {
  hsva: string;
  setHsva: (color: string) => void;
  updateColor: (color: string) => void;
  onClose?: () => void;
}) => {
  return (
    <Wrapper>
      <Container>
        <div className="topSection">
          <SelectColor color={hsva} />
          <input type="text" value={hsva} readOnly />
          <LightButton onClick={() => updateColor(hsva)}>Save</LightButton>
          {onClose && (
            <CloseButton type="close" onClick={onClose} autoFocus={false} />
          )}
        </div>
        <Chrome
          style={{ width: '310px' }}
          color={hsva}
          showEditableInput={false}
          showAlpha={false}
          onChange={color => {
            setHsva(color.hex);
          }}
        />
      </Container>
      <Container style={{ marginTop: '10px' }}>
        <div className="topSection">
          <p>Recommended colors</p>
        </div>
        <div className="colors">
          <SelectColor color="#FFF1F4" onClick={() => setHsva('#FFF1F4')} />
          <SelectColor color="#FFF4F1" onClick={() => setHsva('#FFF4F1')} />
          <SelectColor color="#F8F1FF" onClick={() => setHsva('#F8F1FF')} />
          <SelectColor color="#F1FDFF" onClick={() => setHsva('#F1FDFF')} />
          <SelectColor color="#F1F5FF" onClick={() => setHsva('#F1F5FF')} />
          <SelectColor color="#FFFDE8" onClick={() => setHsva('#FFFDE8')} />
          <SelectColor color="#F6FFE4" onClick={() => setHsva('#F6FFE4')} />
        </div>
      </Container>
    </Wrapper>
  );
};

export default ColorPicker;
